import React from 'react';

const RentalProgressIndicator = ({ progress }) => {
  const steps = [
    { key: 'submitted', label: 'Submitted' },
    { key: 'listed', label: 'Listed' },
    { key: 'tracking', label: 'Tracking' },
    { key: 'closed', label: 'Closed' }
  ];

  const currentStepIndex = steps.findIndex(step => step.key === progress);

  return (
    <div className="rental-progress-container">
      {steps.map((step, index) => (
        <React.Fragment key={step.key}>
          <div className="progress-step">
            <div className={`step-circle ${index <= currentStepIndex ? 'active' : ''} ${index < currentStepIndex ? 'completed' : ''}`}>
              {index < currentStepIndex ? '✓' : index + 1}
            </div>
            <span className="step-label">{step.label}</span>
          </div>
          {index < steps.length - 1 && (
            <div className={`step-connector ${index < currentStepIndex ? 'completed' : ''}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default RentalProgressIndicator;